import request from "@/api";

export function upload(data) {
    return request({
        url: '/api/common/upload/',
        method: 'post',
        data: data
    })
}

export function download(data) {
    return request({
        url: '/api/common/download',
        method: 'post',
        responseType:'blob',
        data: data
    })
}